    <template>
  <span>
    <form method="POST">
      <div class="step email-password-step center">
        <span v-if="$route.query.redirect">
          <h2><span>ようこそ</span></h2>
        </span>
        <span v-else>
          <h2><span>サインイン</span></h2>
        </span>
        <span v-show="error">
          <p class="text-danger">{{error}}</p>
        </span>
        <p class="text">
          <b-form-input float maxlength="100"
            placeholder="ID"
            v-model.trim="login.username"
            required
          >
          </b-form-input>
        </p>
        <p class="text">
          <span>
            <b-form-input float maxlength="20"
              placeholder="Password"
              v-model="login.password"
              type="password"
              required
            >
            </b-form-input>
          </span>
        </p>
        <p class="submit">
          <b-button modifier="cta" class="button-margin btn" @click.prevent="signIn">
            <span>アカウントにサインイン</span>
          </b-button>
        </p>
      </div>
    </form>
  </span>
</template>

<script>
import { Auth, Logger } from 'aws-amplify'
import AmplifyStore from '@/store/modules/AmplifyStore'

const logger = new Logger('auth_signIn')

export default {
  name: 'auth_signIn',
  data () {
    return {
      login: {
        username: '',
        password: '',
        isErrorEmail: false,
        isErrorPassword: false
      },
      error: null
    }
  },
  methods: {
    validateUsername (username) {
      return username
    },
    validatePassword: function (password) {
      return password
    },
    validate: function () {
      this.error = ''
      this.login.isErrorUsername = !this.validateUsername(this.login.username)
      this.login.isErrorPassword = !this.validatePassword(this.login.password)
      if (this.login.isErrorUsername) {
        this.error = 'IDを正しく入力してください。(F)'
      } else if (this.login.isErrorPassword) {
        this.error = 'パスワードを入力してください。(F)'
      }
      return !this.error
    },
    translateLocalMessage (error) {
      return {
        'NotAuthorizedException': 'IDまたはパスワードが間違っています(S)',
        'UserNotFoundException': '登録されていないIDです(S)',
        'UserNotConfirmedException': 'IDを確認してください(S)'
      }[error.code] || error.message
    },
    signIn: function (event) {
      if (!this.validate()) return
      const that = this
      Auth.signIn(this.login.username.toLowerCase(), this.login.password)
        .then(user => {
          logger.debug('sign in success', user)
          if (user.challengeName) {
            Auth.completeNewPassword(user, this.login.password)
              .then((data) => {
                console.log(data)
              }).catch(error => {
                console.log(error)
              })
          } else {
            AmplifyStore.commit('setUser', user)
            return user
          }
        })
        .then(user => {
          that.user = user
          this.checkUser()
        })
        .catch(err => this.setError(err))
    },
    checkUser () {
      const user = this.user
      if (!user) { return }

      Auth.verifiedContact(user)
        .then(data => {
          logger.debug('verify result', data)
          AmplifyStore.commit('setUserVerification', data)
          this.$router.push(this.$route.query.redirect || '/dashboard')
        })
    },
    confirm: function () {
      Auth.confirmSignIn(this.user, this.code)
        .then(() => {
          this.$router.push('/dashboard')
        })
        .catch(err => this.setError(err))
    },
    forgot: function () {
      this.$router.push('/auth/forgotPassword')
    },
    signUp: function () {
      this.$router.push('/auth/signUp')
    },
    setError: function (err) {
      this.error = this.translateLocalMessage(err) || err
    }
  }
}
</script>

<style scoped>
#login h2 {
  font-family: Camphor,Segoe UI,Open Sans,sans-serif;
  padding: 7px 20px;
  color: #1e2b32;
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  margin-bottom: 17px;
}
#login div#main-body form {
  padding: 14px;
}
#login div#main-body form, #login div#main-body form .step, #login div#main-body form p {
  margin-bottom: 14px;
}
#login div#main-body form p.text label {
  display: block;
  margin: 0 0 3px 1px;
  font-size: 13px;
}
#login div#main-body form p.text input {
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
  color: #000;
  padding: 10px 12px;
  width: 270px;
  border-radius: 5px;
  -ms-box-shadow: inset 0 1px 2px rgba(0,0,0,.18);
  -o-box-shadow: inset 0 1px 2px rgba(0,0,0,.18);
  box-shadow: inset 0 1px 2px rgba(0,0,0,.18);
  -webkit-font-smoothing: antialiased;
  border: 1px solid #bbb;
  border-top-color: #999;
  font-size: 18px;
  height: 49px;
}
#login .btn {
  box-sizing: border-box;
  text-align: center;
  height: 44px;
  width: 270px;
  border-radius: 6px;
  box-shadow: 0 1px 1px rgba(0,0,0,.16);
  background: linear-gradient(#e9798a,#c9494a);
  border: 0;
  padding: 1px;
  display: inline-block;
  text-decoration: none;
}
#login div#main-body form p .button span {
  height: 42px;
  padding: 13px 0 0;
  border-radius: 5px;
  font-size: 14px;
  line-height: 14px;
  text-shadow: 0 1px 1px rgba(0,0,0,.53);
  font-weight: 700;
  display: block;
}

#login div#main-body form p.forgot {
  float: right;
  font-size: 12px;
  line-height: 12px;
  color: #555;
  padding: 0;
  margin-top: 10px;
}
#login div#main-body form p.remember {
  padding: 5px 0;
  color: #555;
  font-size: 12px;
  line-height: 12px;
  text-shadow: 0 1px 0 #fff;
}
#login div#footer, #login div#bottom {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
#login div#footer a {
  display: block;
  padding: 15px;
  border-radius: 6px;
  -ms-box-shadow: inset 0 1px 0 hsla(0,0%,100%,.5),0 1px 0 hsla(0,0%,100%,.5);
  -o-box-shadow: inset 0 1px 0 hsla(0,0%,100%,.5),0 1px 0 hsla(0,0%,100%,.5);
  box-shadow: inset 0 1px 0 hsla(0,0%,100%,.5), 0 1px 0 hsla(0,0%,100%,.5);
  border: 1px solid rgba(14,41,57,.1);
  color: #455b67;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}
#login #footer_spacer {
  height: 60px;
}
#login div#bottom a {
  padding: 5px;
  color: #455b67;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}
</style>
